export const FREE_SHIPPING_MIN_PURCHASE = "gratis_minimo_compra";

// El minimo se compara contra el subtotal de productos menos los codigos de
// descuento aplicados (sin impuestos ni envio). Un minimo invalido nunca
// regala el envio.
export const qualifiesForFreeShippingByMinPurchase = (
  shippingType: string | null | undefined,
  minAmount: number | string | null | undefined,
  subTotal: number,
  discountAmount: number
): boolean => {
  const min = Number(minAmount);
  return (
    shippingType === FREE_SHIPPING_MIN_PURCHASE &&
    Number.isFinite(min) &&
    min > 0 &&
    subTotal - discountAmount >= min
  );
};

export type FreeShippingStatus = {
  applies: boolean;
  reached: boolean;
  missing: number;
  percent: number;
  minAmount: number;
};

export const getFreeShippingStatus = (
  shippingType: string | null | undefined,
  minAmount: number | string | null | undefined,
  cartValue: number
): FreeShippingStatus => {
  const min = Number(minAmount);
  const applies =
    shippingType === FREE_SHIPPING_MIN_PURCHASE &&
    Number.isFinite(min) &&
    min > 0;
  if (!applies) {
    return { applies: false, reached: false, missing: 0, percent: 0, minAmount: 0 };
  }
  const value = Number.isFinite(cartValue) ? Math.max(0, cartValue) : 0;
  const reached = value >= min;
  return {
    applies: true,
    reached,
    missing: reached ? 0 : min - value,
    percent: Math.min(100, (value / min) * 100),
    minAmount: min,
  };
};

export type PaidShippingParams = {
  totalPaid: number;
  subtotal: number;
  taxes: number;
  couponDiscount: number;
  shippingCost: number;
};

export const wasShippingFree = ({
  totalPaid,
  subtotal,
  taxes,
  couponDiscount,
  shippingCost,
}: PaidShippingParams): boolean => {
  const values = [totalPaid, subtotal, taxes, couponDiscount, shippingCost].map(Number);
  if (values.some((value) => !Number.isFinite(value))) return false;
  const [total, sub, tax, discount, cost] = values;
  if (cost <= 0) return false;
  const chargedShipping = total - (sub + tax - discount);
  return Math.abs(chargedShipping) < 1;
};
